var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroadcastLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6181 24.2308V15.2564C25.6181 9.74615 22.6171 5.13333 17.3837 3.91282V2.69231C17.3837 1.20256 16.1577 0 14.6389 0C13.1201 0 11.8941 1.20256 11.8941 2.69231V3.91282C6.6424 5.13333 3.65972 9.72821 3.65972 15.2564V24.2308L0 27.8205V29.6154H29.2778V27.8205L25.6181 24.2308ZM16.4688 24.2308H12.809V20.641H16.4688V24.2308ZM16.4688 17.0513H12.809V9.87179H16.4688V17.0513ZM14.6389 35C16.6517 35 18.2986 33.3846 18.2986 31.4103H10.9792C10.9792 32.3623 11.3647 33.2754 12.0511 33.9486C12.7374 34.6218 13.6683 35 14.6389 35Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastLogo);
export default __webpack_public_path__ + "static/media/broadcast-logo.f6815fa64b2bcaf597d16496b3f48261.svg";
export { ForwardRef as ReactComponent };